import type { MoneyInputProps } from '../money-input';
import { Percent } from 'lucide-react';
import { MoneyInput } from '../money-input';

// `MoneyInput` with a percent suffix. Same wire shape (string) as
// `MoneyInput`. Range validation (0..100) is the caller's job — this
// component only renders the affordance.
type PercentInputProps = Omit<MoneyInputProps, 'trailingIcon'>;

export const PercentInput = (props: PercentInputProps) => (
  <MoneyInput
    {...props}
    trailingIcon={<Percent style={{ height: 14, width: 14 }} />}
  />
);
